module.exports = __webpack_public_path__ + "img/Effective Negotiator.72053ce3.svg";